<div class="st-grid">
  <div class="st-card">
    <div class="st-card__header">
      <h3 class="st-card__title">Paso 0 · Estado</h3>
      <span class="st-badge">✓ OK</span>
    </div>
    <div class="st-rows">
      <div class="st-row"><span class="st-row__label">Status</span><span class="st-row__value">{{ step0?.campaign_status }}</span></div>
      <div class="st-row"><span class="st-row__label">Inicio</span><span class="st-row__value">{{ step0?.start_date }}</span></div>
      <div class="st-row"><span class="st-row__label">Fin</span><span class="st-row__value">{{ step0?.end_date }}</span></div>
    </div>
  </div>

  <div class="st-card">
    <div class="st-card__header">
      <h3 class="st-card__title">Paso 1 · Budget</h3>
      <span class="st-badge">✓ OK</span>
    </div>
    <div class="st-rows">
      <div class="st-row"><span class="st-row__label">Budget</span><span class="st-row__value">{{ formatMoney(step1?.budget) }}</span></div>
      <div class="st-row"><span class="st-row__label">Spend (data)</span><span class="st-row__value">{{ formatMoney(step1?.spend_data) }}</span></div>
      <div class="st-row"><span class="st-row__label">Spend (ad server)</span><span class="st-row__value">{{ formatMoney(step1?.spend_ad_server) }}</span></div>
      <div class="st-row"><span class="st-row__label">Remaining</span><span class="st-row__value">{{ formatMoney(step1?.remaining_budget) }}</span></div>
    </div>
  </div>

  <div class="st-card">
    <div class="st-card__header">
      <h3 class="st-card__title">Paso 2 · Ads escritos</h3>
      <span class="st-badge">✓ OK</span>
    </div>
    <div class="st-rows">
      <div class="st-row"><span class="st-row__label">Ads escritos hoy</span><span class="st-row__value">{{ step2?.ads_written ? 'Sí' : 'No' }}</span></div>
      <div class="st-row"><span class="st-row__label">Filas (defrag)</span><span class="st-row__value">{{ step2?.total_rows }}</span></div>
    </div>
  </div>
</div>
